import { injectable } from "inversify";
import QARepository from "../../repositories/qa.repository";
import QAAgentEntity from "../../entities/qa_agent.entity";
import { Either, isLeft } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/error.entity";
import QAResultEntity from "../../entities/qa_result.entity";
import KeyWordLocalization from "../../../presentation/utils/KeyWordLocalization";
import HumanAgentEntity from "../../entities/human_agent.entity";
import QAResumeRepository from "../../repositories/qa_resume.repository";

interface _Props {
    qaResumeRepository: QAResumeRepository;
}

@injectable()
export default class CheckAudioWithQuestionsUseCase {
    private qaResumeRepository: QAResumeRepository;
    constructor(props: _Props) {
        this.qaResumeRepository = props.qaResumeRepository;
    }
    public call = async (_: {
        audio: File, humanAgent: HumanAgentEntity, aiAgent: QAAgentEntity, onCallBack?: (progress: number, message: string) => void
    }): Promise<Either<ErrorEntity, QAResultEntity>> => {
        const callBackAudio = (progress: number, message: string) => _.onCallBack?.(progress / 2, message);
        _.onCallBack?.(0, KeyWordLocalization.CheckAudioWithQuestionsUseCaseLoadingAudio);
        const audioUrl = await this.qaResumeRepository.uploadAudioForTranscription({
            audio: _.audio,
            iaAgentId: _.aiAgent.id,
            onCallBack: callBackAudio,
            humanAgentId: _.humanAgent.id
        });
        if (isLeft(audioUrl)) {
            return audioUrl;
        }
        _.onCallBack?.(50, KeyWordLocalization.CheckAudioWithQuestionsUseCaseSendingQuestions);
        const callBackQuestions = (progress: number, message: string) => _.onCallBack?.(50 + progress / 2, message);
        const res = await this.qaResumeRepository.getAudioResults({
            humanAgent: _.humanAgent,
            jobId: audioUrl.right,
            onCallBack: callBackQuestions
        });
        return res;
    }
}

export const CheckAudioWithQuestionsUseCaseName = "CheckAudioWithQuestionsUseCase";